module.exports = __webpack_public_path__ + "static/media/mr1_assets.bc2b4420.png";